"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var WarningIcon = function (props) { return (
// tslint:disable:max-line-length
React.createElement("svg", __assign({ width: 11, height: 10 }, props),
    React.createElement("defs", null,
        React.createElement("path", { id: 'prefix__a', d: 'M4.876.374c.292-.499 1.021-.499 1.24 0l4.811 8.556c.22.5-.073 1.07-.656 1.07H.721c-.51 0-.875-.57-.656-1.07L4.876.374zm.146 2.496v4.278h1.094V2.87H5.022zm0 4.991v.713h1.094v-.713H5.022z' })),
    React.createElement("use", { fill: '#C41723', fillRule: 'evenodd', xlinkHref: '#prefix__a' }))
// tslint:enable:max-line-length
); };
exports.WarningIcon = WarningIcon;
//# sourceMappingURL=WarningIcon.js.map